import * as React from 'react';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  size?: 'default' | 'sm';
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className = '', size = 'default', ...props }, ref) => {
    const sizeClass = size === 'sm' ? 'shadcn-label-sm' : 'shadcn-label';
    return (
      <label
        className={`${sizeClass} ${className}`.trim()}
        ref={ref}
        {...props}
      />
    );
  }
);
Label.displayName = 'Label';
